import React, { useEffect, useState } from 'react'
import ItemsApp, { IItemModel } from './ItemsApp'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { Avatar, IconButton } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { IDataDisplayerPagination } from '../../components/DataDisplayer/DataDisplayer'
import { ISearchParam } from '../BaseApp'
import ItemsList from './ItemsList'
import { IDynamicForm } from '../../components/Form/DynamicForm'

interface ISelectedItemBoxProps extends IItemModel {
    resetItem: (id: number) => void
}

function SelectedItemBox(props: ISelectedItemBoxProps){

    const { id, title, thumbnail, resetItem } = props

    return(
        <div className="selected-item-box-field">
            <div className="content-of-selected-item-box-field">

                <div className="thumb-of-selected-item-box-field">
                    <div className="content-of-thumb-of-selected-item-box-field">
                        <Avatar src={thumbnail}>
                            <GenerateIcon icon="image" />
                        </Avatar>
                    </div>
                </div>

                <div className="text-of-selected-item-box-field">
                    <div className="content-of-text-of-selected-item-box-field">
                        <h3>{title}</h3>
                    </div>
                </div>

                <div className="action-button-of-selected-item-box-field">
                    <div className="content-of-action-button-of-selected-item-box-field">
                        <IconButton color="error" onClick={() => resetItem(id)}>
                            <GenerateIcon icon="close" />
                        </IconButton>
                    </div>
                </div>

            </div>
        </div>
    )
}

interface ISelectItemDialogProps {
    open: boolean,
    handleClose: () => void,
    updateItemId: (id: number) => void,
    filterForm?: IDynamicForm
}

function SelectItemDialog(props: ISelectItemDialogProps){

    const { open, handleClose, updateItemId, filterForm } = props

    const [items, setItems] = useState<IItemModel[]>([])
    const [pagination, setPagination] = useState<IDataDisplayerPagination>({
        count: 0,
        current_page: 0,
        total_pages: 0
    })
    const [search, setSearch] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(true)
    const [selectedItems, setSelectedItems] = useState<IItemModel[]>([])
    const [searchParams, setSearchParams] = useState<ISearchParam[]>([])

    return(
        <BasicModalWindow
            shown={open}
            handleClose={handleClose}
            size="lg"
            actionButtons={[]}
        >
            <ItemsList
                customGridDataConfig={{
                    viewItemLink: "",
                    editItemLink: "",
                    disableActionButtons: false,
                    disableDelete: true,
                    disableSelect: true,
                    actionButtons: {
                        pinned: "left",
                        width: 80
                    },
                    filterForm: filterForm
                }}
                customGridActionButtons={[
                    {
                        icon: "new",
                        color: "success",
                        isIconButton: true,
                        // label: "Select",
                        onClick(data, dispatch, navigate) {
                            updateItemId(data.id)
                        },
                    }
                ]}
                customGridHeaderOptions={[]}
                customLoading={loading}
                customItems={items}
                customPagination={pagination}
                customSearch={search}
                customSelectedItems={selectedItems}
                customSearchParams={searchParams}
                customUpdateSearch={(search) => setSearch(search)}
                customSetSelectedItems={(items) => setSelectedItems(items)}
                customUpdateLoadingStatus={(status) => setLoading(status)}
                customUpdateSearchParams={(params) => setSearchParams(params)}
                customAddNewItem={(item) => {
                    setItems([
                        ...items,
                        item
                    ])
                }}
                customUpdateAllItems={(items) => setItems(items)}
                customUpdatePagination={(pagination) => setPagination(pagination)}
            />
        </BasicModalWindow>
    )
}

interface IProps {
    selectedItem: number | null,
    handleChange: (id: number | null) => void,
}

export default function SelectItemField(props: IProps) {

    const disptach = useDispatch()

    const { selectedItem, handleChange } = props

    const [open, setOpen] = useState<boolean>(false)

    const [item, setItem] = useState<IItemModel | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const itemsApp = new ItemsApp()

    /**
     * Load selected item
     */
    const loadItem = () => {
        if (!selectedItem){
            setItem(null)
            return;
        }

        setLoading(true)
        itemsApp.singleInstanceDetails(selectedItem)
            .then(response => {
                setItem(response.data)
                setLoading(false)
                handleChange(response.data.id)
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, disptach)
            })
    }

    useEffect(() => {
        loadItem()
    }, [selectedItem])

    /**
     * No item selected
     */
    const noItemSelected = () => {
        return(
            <span className="no-item-selected-box" onClick={() => setOpen(true)}>Select item</span>
        )
    }

    /**
     * Loading
     */
    const loadingBlock = () => {
        return(
            <span className="no-item-selected-box">Loading...</span>
        )
    }

    return(
        <div className="select-item-dynamic-form-field-container">

            <SelectItemDialog open={open} handleClose={() => setOpen(false)} updateItemId={(id) => {
                handleChange(id)
                setOpen(false)
            }} />

            <div className="selected-item-field-container">
                <div className="content-of-selected-item-field-container">
                    {loading ? loadingBlock() : item !== null ? <SelectedItemBox {...item} resetItem={(id) => handleChange(0)} /> : noItemSelected()}
                </div>
            </div>

        </div>
    )
}